import { CSSProperties, FC } from "react";
import { useDesktop } from "../../../hooks/useDesktop";

import {
  Container,
  Loader,
  LoaderText,
  ProgressBar,
  ProgressPrev,
} from "./LineProgress.styled";
import { useTranslation } from "../../../hooks/useTranslation";

type Props = {
  value: number;
  style?: CSSProperties;
  showTitle?: boolean;
};

export const LineProgress: FC<Props> = ({ value, style, showTitle }) => {
  const { t } = useTranslation();

  const isDesktop = useDesktop();
  return (
    <Container style={style}>
      <ProgressPrev>
        <ProgressBar value={value}></ProgressBar>
        <Loader>
          {(showTitle || isDesktop) && (
            <LoaderText>
              {t("completedProgress")}: <span>{value}%</span>
            </LoaderText>
          )}
        </Loader>
      </ProgressPrev>
    </Container>
  );
};
